import { QUERY_BUILDER_V0 } from 'bones/utils/queryBuilder/migrate/v0/constants';
import { DATA_V0_SCHEMA } from 'bones/utils/queryBuilder/migrate/v0/schemas';
import { QUERY_BUILDER_V1 } from 'bones/utils/queryBuilder/migrate/v1/constants';
import { DATA_V1_SCHEMA } from 'bones/utils/queryBuilder/migrate/v1/schemas';
import { QUERY_BUILDER_V2 } from 'bones/utils/queryBuilder/migrate/v2/constants';
import { DATA_V2_SCHEMA } from 'bones/utils/queryBuilder/migrate/v2/schemas';
import { QUERY_BUILDER_V3 } from 'bones/utils/queryBuilder/migrate/v3/constants';
import { DATA_V3_SCHEMA } from 'bones/utils/queryBuilder/migrate/v3/schemas';
import { QUERY_BUILDER_V4 } from 'bones/utils/queryBuilder/migrate/v4/constants';
import { DATA_V4_SCHEMA } from 'bones/utils/queryBuilder/migrate/v4/schemas';
import {
  ANY_CLASS_IRI_V5,
  COMPARISON_OPERATOR_TYPES_BY_DATATYPE_RANGE_V5,
  ConjunctionV5,
  DATE_SPLIT_SYMBOL_V5,
  DEFAULT_OPERATOR_TYPE_BY_DATATYPE_RANGE_V5,
  DatatypeOperatorTypeV5,
  DatatypeRangeV5,
  DirectionV5,
  INSTANCE_IRI_V5,
  INSTANCE_SPLIT_SYMBOL_V5,
  InstanceOperatorTypeV5,
  OPERATOR_SYMBOLS_BY_DATATYPE_OPERATOR_V5,
  OPERATOR_TYPES_BY_DATATYPE_RANGE_V5,
  ObjectOperatorTypeV5,
  OperatorTypeV5,
  QUERY_BUILDER_V5,
  TEXT_BY_OPERATOR_TYPE_V5,
  XSD_DATATYPE_IRIS_V5,
} from 'bones/utils/queryBuilder/migrate/v5/constants';
import { DATA_V5_SCHEMA } from 'bones/utils/queryBuilder/migrate/v5/schemas';

export const CURRENT_QUERY_BUILDER_VERSION = 5;

export const QUERY_BUILDER_SCHEMA = {
  type: 'object',
  oneOf: [
    {
      properties: {
        version: { type: 'number', enum: [QUERY_BUILDER_V0] },
        data: DATA_V0_SCHEMA,
      },
      additionalProperties: false,
    },
    {
      properties: {
        version: { type: 'number', enum: [QUERY_BUILDER_V1] },
        data: DATA_V1_SCHEMA,
      },
      additionalProperties: false,
    },
    {
      properties: {
        version: { type: 'number', enum: [QUERY_BUILDER_V2] },
        data: DATA_V2_SCHEMA,
      },
      additionalProperties: false,
    },
    {
      properties: {
        version: { type: 'number', enum: [QUERY_BUILDER_V3] },
        data: DATA_V3_SCHEMA,
      },
      additionalProperties: false,
    },
    {
      properties: {
        version: { type: 'number', enum: [QUERY_BUILDER_V4] },
        data: DATA_V4_SCHEMA,
      },
      additionalProperties: false,
    },
    {
      properties: {
        version: { type: 'number', enum: [QUERY_BUILDER_V5] },
        data: DATA_V5_SCHEMA,
      },
      additionalProperties: false,
    },
  ],
  required: ['version', 'data'],
};

type ValueOf<T> = T[keyof T];

export const Conjunction = ConjunctionV5;
export type ConjunctionValue = ValueOf<typeof Conjunction>;

export const Direction = DirectionV5;
export type DirectionValue = ValueOf<typeof Direction>;

export const OperatorType = OperatorTypeV5;
export type OperatorTypeValue = ValueOf<typeof OperatorType>;

export const InstanceOperatorType = InstanceOperatorTypeV5;
export type InstanceOperatorTypeValue = ValueOf<typeof InstanceOperatorType>;

export const ObjectOperatorType = ObjectOperatorTypeV5;
export type ObjectOperatorTypeValue = ValueOf<typeof ObjectOperatorType>;

export const DatatypeOperatorType = DatatypeOperatorTypeV5;
export type DatatypeOperatorTypeValue = ValueOf<typeof DatatypeOperatorType>;

export const ANY_CLASS_IRI = ANY_CLASS_IRI_V5;

export const INSTANCE_IRI = INSTANCE_IRI_V5;

export const INSTANCE_SPLIT_SYMBOL = INSTANCE_SPLIT_SYMBOL_V5;

export const DATE_SPLIT_SYMBOL = DATE_SPLIT_SYMBOL_V5;

export const XSD_DATATYPE_IRIS = XSD_DATATYPE_IRIS_V5;

export type DatatypeRange = DatatypeRangeV5;

export const OPERATOR_SYMBOLS_BY_DATATYPE_OPERATOR =
  OPERATOR_SYMBOLS_BY_DATATYPE_OPERATOR_V5;

export const DEFAULT_OPERATOR_TYPE_BY_DATATYPE_RANGE =
  DEFAULT_OPERATOR_TYPE_BY_DATATYPE_RANGE_V5;

export const OPERATOR_TYPES_BY_DATATYPE_RANGE =
  OPERATOR_TYPES_BY_DATATYPE_RANGE_V5;

export const COMPARISON_OPERATOR_TYPES_BY_DATATYPE_RANGE =
  COMPARISON_OPERATOR_TYPES_BY_DATATYPE_RANGE_V5;

export const TEXT_BY_OPERATOR_TYPE = TEXT_BY_OPERATOR_TYPE_V5;
